<template lang="pug">
include /mixins
+b.tt-checkout-step-summary
  +e.content
    +e.title.P {{ order.last_name }} {{ order.first_name }} {{ order.middle_name }}
    +e.text.P {{ order.phone }} {{ order.email }}
  +e.action
    +e.btn
      +b.tt-button--bordered_grey-v2.A(
        @click.prevent='$emit("change")'
      )
        +e.title.SPAN {{ _('Изменить') }}
</template>

<script>
export default {
  name: 'PersonalSummary',
  props: ['user', 'info', 'order', 'bonusesInfo'],
}
</script>
